import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _get from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/get.js";
import _inherits from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.find.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// User Model
import VuexORM from '@vuex-orm/core';
import Todo from "./Todo";
import Project from "./Project";
import Integration from 'src/store/models/Integration';

var TodoList = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(TodoList, _VuexORM$Model);

  var _super = _createSuper(TodoList);

  function TodoList() {
    _classCallCheck(this, TodoList);

    return _super.apply(this, arguments);
  }

  _createClass(TodoList, [{
    key: "increaseTodosCount",
    value: function increaseTodosCount() {
      var completed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var data = {};

      if (completed) {
        data.completed_todos_count = this.completed_todos_count + 1;
      } else {
        data.todos_count = this.todos_count + 1;
      }

      TodoList.update({
        where: this.todo_list_id,
        data: data
      });
    }
  }, {
    key: "decreaseTodosCount",
    value: function decreaseTodosCount(completed) {
      var data = {};

      if (completed) {
        data.completed_todos_count = this.completed_todos_count - 1;
      } else {
        data.todos_count = this.todos_count - 1;
      }

      TodoList.update({
        where: this.todo_list_id,
        data: data
      });
    }
  }, {
    key: "isEditable",
    value: function isEditable() {
      // the todo is not linked to an integration
      return !this.integration_code || // OR the integration linked to the todo has the TasksWrite feature
      this.integration_code && Integration.query().all().filter(function (integration) {
        return integration.features.reduce(function (acc, feature) {
          return acc || feature === 'TasksWrite';
        }, false);
      }).map(function (integration) {
        return integration.integration_code;
      }).includes(this.integration_code);
    }
  }], [{
    key: "entity",
    get: // This is the name used as module name of the Vuex Store.
    function get() {
      return 'todo-lists';
    }
  }, {
    key: "primaryKey",
    get: function get() {
      return 'todo_list_id';
    } // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.

  }, {
    key: "fields",
    value: function fields() {
      return {
        todo_list_id: this.number(null),
        project_id: this.attr(null),
        project: this.belongsTo(Project, 'project_id', 'project_id'),
        name: this.attr(''),
        integration_code: this.attr(null),
        integration_index: this.attr(null),
        integration_todo_list_id: this.attr(''),
        color: this.attr(''),
        index: this.attr(null),
        todos: this.hasMany(Todo, 'todo_list_id'),
        todos_count: this.attr(0),
        is_personal: this.attr(0),
        completed_todos_count: this.attr(0)
      };
    }
  }, {
    key: "lastUpdatedAt",
    get: function get() {
      return this.store().state.entities.todos.last_updated_at;
    }
  }, {
    key: "insertAtIndex",
    value: function insertAtIndex(todoList) {
      this.query().where('project_id', parseInt(todoList.project_id)).where('index', function (value) {
        return value >= todoList.index;
      }).get().forEach(function (todoList) {
        todoList.index++;
        todoList.$save();
      });
    }
  }, {
    key: "moveToIndex",
    value: function moveToIndex(todoList) {
      var oldTodoList = TodoList.find(todoList.todo_list_id);
      if (oldTodoList.index === todoList.index) return;
      var movedForward = todoList.index > oldTodoList.index;
      this.query().where('project_id', oldTodoList.project_id).where('index', function (value) {
        if (movedForward) {
          return value <= todoList.index && value > oldTodoList.index;
        } else {
          return value >= todoList.index && value < oldTodoList.index;
        }
      }).get().forEach(function (todoList) {
        movedForward ? todoList.index-- : todoList.index++;
        todoList.$save();
      });
    }
  }, {
    key: "deleteById",
    value: function deleteById(todoListId) {
      var todoList = TodoList.find(todoListId);
      if (!todoList) return; // the todoList could be already deleted

      this.query().where('project_id', parseInt(todoList.project_id)).where('index', function (value) {
        return value >= todoList.index;
      }).get().forEach(function (todoList) {
        todoList.index--;
        todoList.$save();
      });

      _get(_getPrototypeOf(TodoList), "delete", this).call(this, todoListId);
    }
  }]);

  return TodoList;
}(VuexORM.Model);

_defineProperty(TodoList, "apiConfig", {
  actions: {
    fetch: function fetch(queryParams) {
      return this.get('todo-lists', queryParams).then(function (result) {
        return result;
      });
    },
    fetchById: function fetchById(id) {
      return this.get("/todo-lists/".concat(id)).then(function (result) {
        return result;
      });
    },
    store: function store(data) {
      return this.post('/todo-lists', data).then(function (result) {
        TodoList.commit(function (state) {
          state.last_updated_at = Date.now();
        });
        return result;
      });
    },
    update: function update(id, data) {
      return this.put("/todo-lists/".concat(id), data).then(function (result) {
        TodoList.commit(function (state) {
          state.last_updated_at = Date.now();
        });
        return result;
      });
    },
    destroy: function destroy(id) {
      return this.delete("/todo-lists/".concat(id), {
        delete: id
      }).then(function () {
        TodoList.commit(function (state) {
          state.last_updated_at = Date.now();
        });
      });
    }
  }
});

export { TodoList as default };